const apiUrl = process.env.REACT_APP_API_URL;

export const GetProjecteRubrica = async (id_projecte: string, id_recuperacio?: number) => {
    try {
        let url = `${apiUrl}:8061/projectes/${id_projecte}/rubrica`;
        if (id_recuperacio !== undefined) {
            url += `?id_recuperacio=${id_recuperacio === -1 ? "" : id_recuperacio}`;
        }
        const response = await fetch(url);
        if (!response.ok) return [];
        return await response.json();
    } catch (error) {
        console.log('Error:', error);
        return [];
    }
};

export const PostProjecteRubrica = async (id_projecte: string, body: {
    id_modul_ra: number, descripcio: string, pes: number, id_recuperacio?: number
}) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id_projecte}/rubrica`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        if (!response.ok) alert(await response.text());
    } catch (error) {
        console.log('Error:', error);
    }
};

export const PutProjecteRubrica = async (id: number, body: { descripcio: string, pes: number }) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/rubrica/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        if (!response.ok) alert(await response.text());
    } catch (error) {
        console.log('Error:', error);
    }
};

export const DeleteProjecteRubrica = async (id: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/rubrica/${id}`, { method: 'DELETE' });
        if (!response.ok) alert(await response.text());
    } catch (error) {
        console.log('Error:', error);
    }
};
